module.exports = __webpack_public_path__ + "static/Hydra-e8827f920cc0322733ca1423dbbd5841.jpg";